/**
 * @fileoverview A régua de ocupação da tela de Empresas (lista, detalhe e plano
 * da Empresa): o semáforo e a barra. As classes vêm de quem usa (CompaniesByGroup).
 */

import React from "react";

// Semáforo de ocupação — ÚNICA régua da tela (lista e KPIs do detalhe):
// verde normal · âmbar ≥ 80% · vermelho 100%. Sem limite → neutro. Limite 0 = cheio.
export const meterState = (used, limit) => {
  const hasLimit = limit != null;
  const ratio = hasLimit ? (limit > 0 ? used / limit : 1) : null;
  const pct = hasLimit ? Math.min(100, Math.round(ratio * 100)) : 0;
  const tone = !hasLimit ? "none" : ratio >= 1 ? "full" : ratio >= 0.8 ? "warn" : "ok";
  return { hasLimit, ratio, pct, tone };
};
const meterToneClass = (classes, tone) =>
  ({ none: classes.meterNone, full: classes.meterFull, warn: classes.meterWarn, ok: classes.meterOk }[tone]);

// Só a barra (trilha + preenchimento). Usada pelo LimitMeter e pelos KPI cards.
export const MeterBar = ({ classes, used, limit, small = false, className = "" }) => {
  const { hasLimit, pct, tone } = meterState(used, limit);
  return (
    <div className={`${classes.meterBarWrap} ${meterToneClass(classes, tone)}${className ? ` ${className}` : ""}`} aria-hidden="true">
      <div className={`${classes.meterTrack}${small ? ` ${classes.meterTrackSm}` : ""}`}>
        <div className={classes.meterFill} style={{ width: hasLimit ? `${pct}%` : "0%" }} />
      </div>
    </div>
  );
};

// Label + valor colorido + barra. Sem limite → valor "X · sem limite".
// `hideLabel` esconde a linha de cabeçalho (tabela), mantendo o label no a11y.
export const LimitMeter = ({ classes, label, used, limit, small = false, hideLabel = false }) => {
  const { hasLimit, pct, tone: toneKey } = meterState(used, limit);
  const tone = meterToneClass(classes, toneKey);
  return (
    <div
      className={`${classes.meter} ${tone}`}
      title={hasLimit ? `${label}: ${used} de ${limit} (${pct}%)` : `${label}: ${used} · sem limite`}
      role="group"
      aria-label={hasLimit ? `${label}: ${used} de ${limit}` : `${label}: ${used}, sem limite`}
    >
      <div className={classes.meterHead}>
        {!hideLabel && <span className={classes.meterLabel}>{label}</span>}
        <span className={classes.meterValue}>
          {used}
          {hasLimit
            ? <span className={classes.meterValueMuted}> / {limit}</span>
            : <span className={classes.meterValueMuted}> · sem limite</span>}
        </span>
      </div>
      <MeterBar classes={classes} used={used} limit={limit} small={small} />
    </div>
  );
};
